import ProductAccountCardComponent from "components/Reports/AccountCard/ProductAccountCardComponent";
import Table from "components/Table";
import React, { useState } from "react";
import { Card, Header } from "../TablePrintTopComp";

const ProductAccountCard = () => {
  const [activeTab, setActiveTab] = useState<string>();
  const [options, setOptions] = useState({});
  const [state, setState] = useState<ProductPrintCompProps>({});
  return (
    <Table
      type="productAccountCard"
      middleComp={
        <ProductAccountCardComponent tab={activeTab} options={options} onChange={(s) => setState(s)} />
      }
      onTabChange={(options) => {
        setActiveTab(options.activeTab.apiKey);
        setOptions((x) => ({ ...x, ...options.paginationState }));
      }}
      onSearch={(options) => setOptions(options)}
      printComp={ProductPrintComp(state)}
    />
  );
};

interface ProductPrintCompProps {
  product?: any;
  dates?: any;
}

function ProductPrintComp(props: ProductPrintCompProps) {
  const product = props.product || {};
  const toDate = props.dates?.toDate;
  const fromDate = props.dates?.fromDate;
  const count = product.count;
  const CT = `موجودی کل (انبارها + حسابداری) : ${count} عدد`;
  const RD = toDate && fromDate ? `گزارش ازتاریخ :${fromDate} تا تاریخ :${toDate}` : "گزارش برای کل سال مالی";
  const name = product.title ? `کارت حساب ${product.title}` : "";
  return (
    <div>
      <Header texts={[RD, name, CT]} />
      <div style={{ display: "flex", padding: 12, gap: 24 }}>
        <Card
          title="فروش"
          items={[
            { title: "تعداد فروش", count: product.Sold },
            { title: "تعداد فاکتور", count: product.countSaleFactors },
            { title: "مجموع", price: product.totalAmountSaleFactor },
            { title: "سود", price: product.totalAmountSold },
          ]}
        />
        <Card
          title="خرید"
          items={[
            { title: "تعداد فروش", count: product.bought },
            { title: "تعداد فاکتور", count: product.countBuyFactors },
            { title: "مجموع", price: product.totalAmountBuyFactor },
          ]}
        />
      </div>
    </div>
  );
}

export default ProductAccountCard;
